import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View, Platform } from 'react-native';
import { pipe } from 'lodash/fp';
import noop from 'lodash';
import Button from '../../../components/common/button-view';
import Device from 'react-native-device-detection';
import { FormGroup, TextInput, Message, Label } from '@dbk/ui-forms';
import { isNative, isE2E } from '@dbk/ui-react-utils';
import Text from '@dbk/ui-text';
import { IconButton } from '@dbk/ui-buttons';
import { QuestionMark } from './../../../components/common/icons/';
import BlurModal from './../../../components/common/blur-modal';
import Popover from '../../../components/popover';
import { testIDProps } from '../utils/with-automation-id-props';
import { DOT_UNICODE, CHANNEL_TYPES, PALETTE } from '../../../constants';
// import styles from './styles';
class LoginForm extends PureComponent {

  constructor(props) {
    super(props);
    this.onTextBoxFocus = this.onTextBoxFocus.bind(this);
    this.clearTextBoxFocus = this.clearTextBoxFocus.bind(this);
    this.state = {
      activeTextBox: "",
      selection: { start: 0, end: 0 },
      userId: undefined,
      password: '',
      maskedPwd: '',
      // showConfirmPwdHideIcon: false
    }
  }

  clearTextBoxFocus() {
    this.setState({ activeTextBox: "" });
  }

  onTextBoxFocus(textField) {
    this.setState({ activeTextBox: textField });
    this.props.handleTextFieldEnterPress();
  }

  onSelectionChange = ({ nativeEvent: { selection } }) => {
    const { userId } = this.state;
    if (this.props.config && this.props.config.regionCode && this.props.config.regionCode.toUpperCase() === 'CH' && selection.start !== selection.end) {
      this.setState({ selection: { start: selection.end, end: selection.end } });
    }
    else {
      this.setState({ selection: { start: selection.start > userId.length ? userId.length : selection.start, end: selection.end > userId.length ? userId.length : selection.end } });
    }
  }

  handleInputChanged = ({ name, value }) => {
    const sanitizedValue = value.replace(/\s/g, "");

    if(name === 'userId') {
      this.setState({[name]:sanitizedValue.toUpperCase()});
    } else if(this.props.appChannel !== CHANNEL_TYPES.WEB && name === 'password') {
      let newPassword = '';
      const lastRecord = sanitizedValue.slice(sanitizedValue.length - 1);
      const isUniCodeChar = lastRecord === DOT_UNICODE;
      if(this.props.appChannel !== CHANNEL_TYPES.WEB){

        if(this.state.password.length < sanitizedValue.length && !isUniCodeChar){
          newPassword = `${this.state.password}${lastRecord}`;
        } else if(this.state.password.length > sanitizedValue.length && isUniCodeChar ){
          newPassword = this.state.password.slice(0, - 1);
        }
         this.setState({[name]:newPassword, maskedPwd: DOT_UNICODE.repeat(sanitizedValue.length)});

      }


    // WMCE-7106 commented below code as need to revisit it again
    // if(this.props.appChannel === CHANNEL_TYPES.WEB) {
    //   const pwdField = document.getElementById('loginPasswordSelection');
    //   const startPosition = pwdField.selectionStart;
    //   const endPosition = pwdField.selectionEnd;

    //   if(this.state.password.length < sanitizedValue.length && !isUniCodeChar){
    //     newPassword = `${this.state.password}${lastRecord}`;
    //   } else if(this.state.password.length > sanitizedValue.length && isUniCodeChar && sanitizedValue.length === startPosition && sanitizedValue.length === endPosition){
    //     newPassword = this.state.password.slice(0, - 1);
    //   } else {
    //     newPassword = this.state.password.slice(0,startPosition) + this.state.password.slice(startPosition+1);
    //   }
    //    this.setState({[name]:newPassword, maskedPwd: DOT_UNICODE.repeat(sanitizedValue.length)});
    //   }
    } else {
      this.setState({[name]:sanitizedValue});
    }


  };

  render() {
    let smallDevice = false;
    const {
      i18n: { messages },
      nativeStyle,
      handleSetupNewPassword,
      isLoginBusy,
      showUserPopover,
      showPasswordPopover,
      handleShowUserPopover,
      handleShowPasswordPopover,
      handleEnterPress,
      handleTextFieldEnterPress,
      isTablet,
      applyAndroidStyles,
      handleForgotPasswordPage,
      app: { config: { showchangepassword } },
      auth: { channel },
      appChannel
    } = this.props;


    if (Device.height <= 667) {
      smallDevice = true;
    }

    const regionCode = this.props.config && this.props.config.regionCode;
    const onInputChanged = pipe(this.props.onChange, this.handleInputChanged);
    const extraInputProps = (name) => isNative
      ? {
        onChangeText: (value) => onInputChanged(name, value),
      }
      : {
        onChange: onInputChanged,
      };

    let formGroupLastMarginLogin = Platform.OS === 'android' && !isTablet ? nativeStyle.formGroupLastMarginLoginAndroid : nativeStyle.formGroupLastMargin;
    let formGroupStyle = nativeStyle.formGroup;
    let labelStyle = nativeStyle.labelStyle;
    let buttonStyle = nativeStyle.buttonStyle;
    if (applyAndroidStyles && Platform.OS === 'android' && !isTablet) {
      formGroupLastMarginLogin = nativeStyle.formGroupLastMarginLoginAndroid;
      formGroupStyle = smallDevice ? nativeStyle.formGroupAndroid : nativeStyle.formGroup;
      labelStyle = nativeStyle.labelStyleLoginAndroid;
      buttonStyle = nativeStyle.buttonAndroid;
    }
    const inputFieldsAreEmpty = !this.state.userId || !this.state.password;

    const showPasswordPopoverCH =  showPasswordPopover && regionCode === 'CH' ;

    const zIndexIOS = { zIndex: 1 } ; // WMCE-6767 - Android tooltip not working with zIndex  // WMCE-16096- Andriod app zIndex needed for questionmark icon

    return (
      <View className="LoginForm">
        <FormGroup style={formGroupStyle}>
          <View {...testIDProps("lbl_loginPage_userName_login_test")}>
            <Label style={labelStyle}
              id="lbl_loginPage_userName_login_test"
              {...testIDProps("label_text_loginPage_userName_login_test")}
            >{messages['app.auth.username']}</Label>
          </View>
          <View className='form__input-wrapper' style={nativeStyle.inputWrapper}>
            {/* <View className='form__question-mark' style={[nativeStyle.questionMark,zIndexIOS ]}>
              <View className={'form_question-mark-wrapper'}>
                {showUserPopover && <Popover
                  onPress={() => { }}
                  style={nativeStyle.questionMarkPopover}
                  arrowStyle={nativeStyle.questionMarkPopoverArrow}
                  title={messages['app.login.popover.username.title']}
                  content={
                    <Text style={nativeStyle.secondaryTextLogin} className={'popover__content'}>
                      {messages['app.login.popover.username.content']}
                    </Text>
                  }
                  isActive={showUserPopover}
                  className={'popover__username'}
                  accessible={showUserPopover}
                />}
                <IconButton id="icon_loginPage_userName_login_test"
                  {...testIDProps("tooltip_loginPage_userName_login_test")}
                  tabindex="-1" onPress={
                    handleShowUserPopover
                  }>
                  <QuestionMark width={22} height={22} />
                </IconButton>
              </View>
            </View> */}
            <TextInput
              style={this.state.activeTextBox == "username" ? nativeStyle.inputActive : nativeStyle.input}
              {...testIDProps("input_loginPage_userName_login_test")}
              name="userId"
              id="loginUserNameSelection"
              // error={userIdEmpty}
              size="large"
              value={this.state.userId}
              placeholder={messages['app.auth.username.placeholder']}
              {...extraInputProps('userId')}
              zIndex={-1}
              autoFocus="on"
              selectTextOnFocus={false}
              caretHidden={regionCode && regionCode.toUpperCase() === 'CH' ? false : Platform.OS === 'android' ? true : false}
              contextMenuHidden={true}
              onKeyPress={handleEnterPress}
              onFocus={() => this.onTextBoxFocus("username")}
              onBlur={() => this.clearTextBoxFocus()}
              underlineColorAndroid="transparent"
              selection={(Platform.OS === 'android') ?null: this.state.selection  }
              onSelectionChange={(Platform.OS === 'android') ? null:  this.onSelectionChange}
              autoCorrect={false}
              autoComplete="off"
              autoCompleteType="off"
              autoCapitalize={'characters'}
              keyboardType = {Platform.OS === 'android'?"visible-password": null}
            />
          </View>
        </FormGroup>
        <FormGroup style={formGroupLastMarginLogin}>
          <View {...testIDProps("lbl_loginPage_password_login_test")}>
            <Label style={labelStyle}
              id="lbl_loginPage_password_login_test"
              {...testIDProps("label_text_loginPage_password_login_test")}
            >{messages['app.auth.password']}</Label>
          </View>
          <View className='form__input-wrapper'>
            {/* <View className='form__question-mark' style={[nativeStyle.questionMark, zIndexIOS]}>
              <View className={'form_question-mark-wrapper'}>
                {showPasswordPopover && Platform.OS !== 'android' ?
                <Popover
                  onPress={() => { }}
                  style={nativeStyle.questionMarkPopover}
                  arrowStyle={nativeStyle.questionMarkPopoverArrow}
                  title={showPasswordPopoverCH ? null : messages['app.login.popover.password.title']}
                  accessible={false}
                  content={
                    <View >
                      {showchangepassword ?
                        <View>
                        {showPasswordPopoverCH ?
                          <Text className='form__forget-password-click-button'   style={nativeStyle.forgetPasswordClickButton} style={{ color: PALETTE.primaryActive }}
                            onPress={handleSetupNewPassword}
                            onClick={handleSetupNewPassword}>
                            {messages['app.login.popover.password.title']}
                          </Text>
                          : <Text style={nativeStyle.secondaryTextLogin} className={'popover__content'}>
                            {messages['app.forgotPassword.popover.content']}
                            {' '}
                            <Text
                              onPress={handleSetupNewPassword}
                              onClick={handleSetupNewPassword}
                              style={nativeStyle.forgetPasswordClickButton}
                              className='form__forget-password-click-button'
                            >
                              {messages['app.login.popover.password.link']}
                            </Text>
                          </Text>}
                      </View>
                        :
                        <Text style={nativeStyle.secondaryTextLogin}>
                          {messages['app.auth.forgottenPassword.text']}
                        </Text>
                      }
                    </View>
                  }
                  isActive={showPasswordPopover}
                  accessible={showPasswordPopover}
                />
                : 
                showPasswordPopover && <View>
                  <BlurModal
                    visible={showPasswordPopover }
                    onDone={handleShowPasswordPopover}
                    >
                    <Text onPress={handleSetupNewPassword} style={nativeStyle.forgetPasswordClickButton}>{messages['app.login.popover.password.title']}</Text>
                  </BlurModal>
                </View>
              }
                <IconButton id="icon_loginPage_password_login_test"
                  {...testIDProps("tooltip_loginPage_password_login_test")}
                  tabindex="-1" onPress={
                    handleShowPasswordPopover
                  }>
                  <QuestionMark width={22} height={22} />
                </IconButton>
              </View>
            </View> */}
            <TextInput
              style={this.state.activeTextBox == "password" ? nativeStyle.inputActive : nativeStyle.input}
              zIndex={-1}
              placeholder={messages['app.auth.password.placeholder']}
              type={channel === CHANNEL_TYPES.WEB ? "password" : "text"}
              secureTextEntry
              size="large"
              id="loginPasswordSelection"
              name="password"
              value={channel === CHANNEL_TYPES.WEB ?  this.state.password : this.state.maskedPwd}
              // error={passwordEmpty}
              {...testIDProps("input_loginPage_password_login_test")}
              {...extraInputProps('password')}
              selectTextOnFocus={false}
              caretHidden={regionCode && regionCode.toUpperCase() === 'CH' ? true : Platform.OS === 'android' ? true : false}
              contextMenuHidden={true}
              onKeyPress={handleEnterPress}
              onFocus={() => this.onTextBoxFocus("password")}
              onBlur={() => this.clearTextBoxFocus()}
              underlineColorAndroid="transparent"
              autoComplete="off"
              autoCompleteType="off"
            />
          </View>
        </FormGroup>
        {inputFieldsAreEmpty ?
          <Button
            {...testIDProps("header_btn_disbaled_loginScreenView_test")}
            disabled
            fullWidth
            size='large'
            loading={isLoginBusy}
            style={buttonStyle}
          >
            {messages['app.auth.login']}
          </Button>
          :
          <Button
            {...testIDProps("header_btn_enabled_loginScreenView_test")}
            fullWidth
            disabled={regionCode && regionCode.toUpperCase() === 'CH'?isLoginBusy: false}
            size='large'
            loading={isLoginBusy}
            style={buttonStyle}
            onPress={() => this.props.onLogin(this.state.userId, this.state.password)}
          >
            {messages['app.auth.login']}
          </Button>
        }
      </View>
    );
  }
}

LoginForm.propTypes = {
  onChange: PropTypes.func.isRequired,
  handleSetupNewPassword: PropTypes.func,
  nativeStyle: PropTypes.object,
  handleEnterPress: PropTypes.func,
  handleTextFieldEnterPress: PropTypes.func,
  isLoginBusy: PropTypes.bool,
  handleShowPasswordPopover: PropTypes.func,
  handleShowUserPopover: PropTypes.func,
  showUserPopover: PropTypes.bool,
  showPasswordPopover: PropTypes.bool,
  onLogin: PropTypes.func,
  i18n: PropTypes.object,
  config: PropTypes.object,
  app: PropTypes.object,
  handleForgotPasswordPage: PropTypes.func

};

LoginForm.defaultProps = {
  onChange: noop,
  nativeStyle: {},
  handleSetupNewPassword: () => { },
  handleEnterPress: () => { },
  handleTextFieldEnterPress: () => { },
  handleForgotPasswordPage: () => {}
};

export default LoginForm;
